// KALLPA — aparición al hacer scroll para tarjetas de catálogo, búsqueda y blog.
// Se aplica globalmente vía selector (sin tocar cada plantilla) y respeta
// prefers-reduced-motion.
(function () {
  if (window.__kallpaRevealInit) return;
  window.__kallpaRevealInit = true;

  var SELECTOR = '.product-card, .collection-card, .blog-post-card, .mini-testimonial, .ingredient-comparison, .stock-urgency';

  function init() {
    var items = document.querySelectorAll(SELECTOR);
    if (!items.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    items.forEach(function (el) {
      el.classList.add('kallpa-reveal');
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach(function (el, i) {
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
